import { gql } from '@apollo/client';

export const READ_EXTERNAL_PAYMENT_METHODS = gql`
  query ReadExternalPaymentMethods($countryCode: CountryCode!) {
    readExternalPaymentMethods(countryCode: $countryCode) {
      paymentMethods
    }
  }
`;
